import NotificationItem from "../../common/items/NotificationItem";
import { useEffect, useState } from "react";

import { ajaxor2 } from '../../common/basic';

export default props=>{

    const [vNotiList, setNotiList] = useState([,]);
    useEffect(()=>{

        if(typeof localStorage["loginer"] == 'undefined') return;

        ajaxor2({
            url:"/user/events",
            callback: setNotiList
        });

        return ()=>{;};
    },[]);
    return (<div className="this-content">
        <style jsx>{`
.this-content{
    width: 312px;
    height: 400px;
    overflow-x: hidden;
    overflow-y: scroll;
}


.no-result{
    text-align: center;
    padding-top: 20px;
}


`}</style>


        {vNotiList && vNotiList.map((v, i) => 
            <NotificationItem key={i} me={v} />
        )}
        {vNotiList.length ? null : 
            <div className="no-result">알림이 없습니다.</div>
        }
    </div>);
}

